module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-vertical-5cb6955b0befe522fba9d73736cc1a99.svg";